module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltySpring@3x.cdc06a00.png";